import ApiBase from './api-base'
import { ACTIVE_BASE_REST } from './constants'
export default class ManageDriver extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/order'
    super(store, path)
  }
  startCar(id, showProgress) {
    return this._request({
      action: `orderCar/${this._urlencode(id)}/startService`,
      method: 'POST',
      showProgress
    })
  }
  reachOrgin(id, showProgress) {
    return this._request({
      action: `service/${this._urlencode(id)}/reachOrigin`,
      method: 'PATCH',
      showProgress
    })
  }
  start(id, showProgress) {
    return this._request({
      action: `${this._urlencode(id)}/start`,
      method: 'PATCH',
      showProgress
    })
  }
  finishNoCar(id, showProgress) {
    return this._request({
      action: `${this._urlencode(id)}/finish`,
      method: 'PATCH',
      showProgress
    })
  }
  startLoading(id, showProgress) {
    return this._request({
      action: `service/${this._urlencode(id)}/startLoading`,
      method: 'PATCH',
      showProgress
    })
  }
  reachDestination(id, showProgress) {
    return this._request({
      action: `service/${this._urlencode(id)}/reachDestination`,
      method: 'PATCH',
      showProgress
    })
  }
  finish(id, showProgress) {
    return this._request({
      action: `service/${this._urlencode(id)}/finish`,
      method: 'PATCH',
      showProgress
    })
  }
  New(id, showProgress) {
    return this._request({
      action: `service/${this._urlencode(id)}/new`,
      method: 'PATCH',
      showProgress
    })
  }
}
